import { render, staticRenderFns } from "./ProductListToolbarSortSelect.vue?vue&type=template&id=2b296906"
import script from "./ProductListToolbarSortSelect.vue?vue&type=script&lang=ts"
export * from "./ProductListToolbarSortSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports